import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import * as React from 'react';
import { cn } from '../../utils/cn';

type ToolTipArrowConfig = { isVisible: false } | { isVisible: true; className?: string };

const TooltipProvider = TooltipPrimitive.Provider;

const TooltipRoot = TooltipPrimitive.Root;

const TooltipTrigger = TooltipPrimitive.Trigger;

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content> & {
    arrowConfig?: ToolTipArrowConfig;
  }
>(({ className, sideOffset = 4, children, arrowConfig = { isVisible: false }, ...props }, ref) => (
  <TooltipPrimitive.Content
    ref={ref}
    sideOffset={sideOffset}
    className={cn(
      'z-50 origin-(--radix-tooltip-content-transform-origin) animate-in overflow-hidden rounded-lg border border-border bg-white px-4 py-3 text-sm text-muted-foreground shadow-md fade-in-0 zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95',
      className,
    )}
    {...props}
  >
    {children}

    {arrowConfig.isVisible && (
      <TooltipPrimitive.Arrow
        className={cn(
          'z-50 size-2.5 translate-y-[calc(-50%_-_2px)] rotate-45 rounded-[2px] bg-white fill-white',
          arrowConfig.className,
        )}
      />
    )}
  </TooltipPrimitive.Content>
));

TooltipContent.displayName = TooltipPrimitive.Content.displayName;

export { TooltipContent, TooltipProvider, TooltipRoot, TooltipTrigger };
